import logo from './logo.png';
import logo_white from './logoWhite.png';
import googlePlay from './googlePlay.png';
import appleStore from './appleStore.png';

import error_404 from './404.gif';
import error_500 from './500.gif';

export {
  logo,
  logo_white,
  appleStore,
  googlePlay,
  error_404,
  error_500,
};
